/* Cart Cross Sell */
(function () {
  'use strict';

  class CartCrossSell extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      if (this.dataset.productId) {
        this.loadRecommendations();
        return;
      }
      this.error = this.querySelector('[data-cross-sell-error]');

      this.querySelectorAll('[data-cross-sell-item]').forEach((item) => this.updateVariant(item));

      this.addEventListener('change', (event) => {
        const option = event.target.closest('[data-cross-sell-option]');
        if (option) {
          this.updateVariant(option.closest('[data-cross-sell-item]'));
        }
      }, { signal: this.abortController.signal });

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-cross-sell-add]');
        if (!button) {
          return;
        }
        this.add(button.closest('[data-cross-sell-item]'), button);
      }, { signal: this.abortController.signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    async loadRecommendations() {
      const response = await fetch(
        `${window.Shopify.routes.root}recommendations/products?product_id=${this.dataset.productId}&limit=10&section_id=${this.dataset.sectionId}`,
        { signal: this.abortController.signal }
      ).catch(() => null);
      if (!response || !response.ok) return;

      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const crossSell = html.querySelector('[data-cart-cross-sell]');
      if (crossSell) {
        this.replaceWith(crossSell);
      }
    }

    selectedVariant(item) {
      const options = Array.from(item.querySelectorAll('[data-cross-sell-option]'), (select) => select.value);
      return JSON.parse(item.dataset.crossSellVariants).find((variant) =>
        options.every((value, index) => variant.options[index] === value)
      );
    }

    updateVariant(item) {
      const variant = this.selectedVariant(item);
      const button = item.querySelector('[data-cross-sell-add]');
      const price = item.querySelector('[data-cross-sell-price]');
      const compare = item.querySelector('[data-cross-sell-compare]');

      button.disabled = !variant || !variant.available;
      button.setAttribute('aria-label', !variant ? this.dataset.unavailableLabel :
        variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel);
      price.innerHTML = variant ? theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat) : '';
      compare.hidden = !variant || !(variant.compare_at_price > variant.price);
      compare.innerHTML = compare.hidden ? '' : theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);

      const image = item.querySelector('[data-cross-sell-image]');
      if (image) {
        const src = variant && variant.featured_image ? variant.featured_image.src : image.dataset.crossSellImage;
        image.srcset = [64, 128].map((width) => `${this.imageUrl(src, width)} ${width}w`).join(', ');
        image.src = this.imageUrl(src, 128);
      }
    }

    imageUrl(src, width) {
      const url = new URL(src, window.location.href);
      url.searchParams.set('width', width);
      return url.toString();
    }

    async add(item, button) {
      if (button.disabled) return;
      const variant = this.selectedVariant(item);
      if (!variant || !variant.available) return;
      const options = item.querySelectorAll('[data-cross-sell-option]');

      button.disabled = true;
      options.forEach((select) => { select.disabled = true; });
      button.classList.add('btn--loading');
      this.error.hidden = true;

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
      }).catch(() => null);
      const result = response ? await response.json().catch(() => null) : null;

      button.classList.remove('btn--loading');
      options.forEach((select) => { select.disabled = false; });
      this.updateVariant(item);

      if (!response || !response.ok) {
        this.error.textContent = result ? result.description || result.message : '';
        this.error.hidden = false;
        return;
      }

      document.dispatchEvent(new CustomEvent('cart:build'));
    }
  }

  if (!window.customElements.get('cart-cross-sell')) {
    window.customElements.define('cart-cross-sell', CartCrossSell);
  }
})();
